module.exports = __webpack_public_path__ + "static/media/bannerCarbo.bb3052be.png";